import { IHttpService } from "../HttpService";
import Device, { IDevice } from "../../model/device/Device";
import { IUserCredential } from "../../model/user/UserCredential";

export interface IDeviceService {
  getDevices(userCredentials: IUserCredential): Promise<IDevice[]>;
  removeDevice(
    deviceId: number,
    userCredentials: IUserCredential
  ): Promise<any>;
}

const DeviceService = ({
  httpService
}: {
  httpService: IHttpService;
}): IDeviceService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/devices";
  const _removeUrl: string = "remove";

  const DeviceMapper = (json = []) => {
    return json.map((item: any) => {
      return Device(item);
    });
  };

  let GetDevicesParamsMapper = (userCredential: IUserCredential) => {
    return {
      username: userCredential.username,
      password: userCredential.password,
      language: userCredential.language ? userCredential.language : null
    };
  };

  let RemoveDeviceParamsMapper = (
    deviceId: number,
    userCredential: IUserCredential
  ) => {
    return {
      deviceId: deviceId,
      password: userCredential.password,
      username: userCredential.username,
      language: userCredential.language
    };
  };

  return {
    async getDevices(userCredential: IUserCredential) {
      const path = _http.buildPath(_baseUrl);
      const _params = GetDevicesParamsMapper(userCredential);
      const response = await _http.post(path, {
        form: true,
        params: _params
      });
      const responseJSON = await _http.toJSON(response);
      return DeviceMapper(responseJSON);
    },

    async removeDevice(deviceId: number, userCredential: IUserCredential) {
      const path = _http.buildPath(_baseUrl, deviceId.toString(), _removeUrl);
      const _params = RemoveDeviceParamsMapper(deviceId, userCredential);
      const response = await _http.post(path, {
        form: true,
        params: _params
      });
      return _http.toText(response);
    }
  };
};

export default DeviceService;
